import TablaAgentes from './TablaAgentes';
export default TablaAgentes;